import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './styles/tokens.css';
import './styles/global.css';
import './styles/art-direction-v2.css';
import './styles/system-v3.css';

if ('serviceWorker' in navigator && import.meta.env.PROD) window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js'));

createRoot(document.getElementById('root')!).render(<StrictMode><App/></StrictMode>);
